export const GET_PROPERTY_LIST = 'GET_PROPERTY_LIST';
export const GET_PROPERTY_LIST_START = 'GET_PROPERTY_LIST_START';
export const GET_PROPERTY_LIST_SUCCESS = 'GET_PROPERTY_LIST_SUCCESS';
export const GET_PROPERTY_LIST_FAIL = 'GET_PROPERTY_LIST_FAIL';
export const CREATE_PROPERTY_START = 'CREATE_PROPERTY_START';
export const CREATE_PROPERTY_SUCCESS = 'CREATE_PROPERTY_SUCCESS';
export const CREATE_PROPERTY_FAIL = 'CREATE_PROPERTY_FAIL';
export const CREATE_PROPERTY = 'CREATE_PROPERTY';
export const MINT_PROPERTY = 'MINT_PROPERTY';
export const MINT_PROPERTY_SUCCESS = 'MINT_PROPERTY_SUCCESS';
export const MINT_PROPERTY_FAIL = 'MINT_PROPERTY_FAIL';
export const MINT_PROPERTY_START = 'MINT_PROPERTY_START';
export const PUT_ON_SALE = 'PUT_ON_SALE';
export const PUT_ON_SALE_SUCCESS = 'PUT_ON_SALE_SUCCESS';
export const PUT_ON_SALE_FAIL = 'PUT_ON_SALE_FAIL';
export const PUT_ON_SALE_START = 'PUT_ON_SALE_START';
export const BUY_EQUITY = 'BUY_EQUITY';

export const DELETE_PROPERTY = 'DELETE_PROPERTY';
export const DELETE_PROPERTY_START = 'DELETE_PROPERTY_START';
export const DELETE_PROPERTY_SUCCESS = 'DELETE_PROPERTY_SUCCESS';
export const DELETE_PROPERTY_FAIL = 'DELETE_PROPERTY_FAIL';

export const GET_CROWDSALE_REFUND_PREVIEW = 'GET_CROWDSALE_REFUND_PREVIEW';
export const GET_CROWDSALE_REFUND_PREVIEW_START = 'GET_CROWDSALE_REFUND_PREVIEW_START';
export const GET_CROWDSALE_REFUND_PREVIEW_SUCCESS = 'GET_CROWDSALE_REFUND_PREVIEW_SUCCESS';
export const GET_CROWDSALE_REFUND_PREVIEW_FAIL = 'GET_CROWDSALE_REFUND_PREVIEW_FAIL';

export const PROCESS_CROWDSALE_REFUND = 'PROCESS_CROWDSALE_REFUND';
export const PROCESS_CROWDSALE_REFUND_START = 'PROCESS_CROWDSALE_REFUND_START';
export const PROCESS_CROWDSALE_REFUND_SUCCESS = 'PROCESS_CROWDSALE_REFUND_SUCCESS';
export const PROCESS_CROWDSALE_REFUND_FAIL = 'PROCESS_CROWDSALE_REFUND_FAIL';

export const CLEAR_REFUND_STATE = 'CLEAR_REFUND_STATE';
